var map = {
	"./HoennEncounters.json": [
		9352,
		117
	],
	"./Johto4Encounters.json": [
		4873,
		690
	],
	"./JohtoEncounters.json": [
		5704,
		782
	],
	"./Kanto3Encounters.json": [
		2667,
		618
	],
	"./KantoEncounters.json": [
		4694,
		199
	],
	"./SinnohEncounters.json": [
		5836,
		104
	],
	"./Unova2Encounters.json": [
		8002,
		878
	],
	"./UnovaEncounters.json": [
		5724,
		182
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7638;
module.exports = webpackAsyncContext;